import { motion } from "framer-motion";
import { ArchCartouche } from "@/components/Mughal";

// Condensed from Amrita's own About page (amritasendesigns.com/about) — her words, abridged.
const BackgroundSection = () => (
  <section data-testid="background-section" className="relative mx-auto w-full max-w-2xl px-6 py-8 md:py-12">
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.2, ease: "easeOut" }}
    >
      <div className="mb-14">
        <ArchCartouche className="text-[#d4af37]/70">
          <span className="text-xs uppercase" style={{ letterSpacing: "0.5em" }}>
            Background
          </span>
        </ArchCartouche>
      </div>
      <div className="font-serif-display flex flex-col gap-8 text-lg font-light leading-relaxed text-[#f3ead6]/75 md:text-xl md:leading-relaxed">
        <p className="dropcap">
          Born to parents who immigrated from Calcutta, she was on stage singing
          at six, and learned to draw watching her mother paint Indian folk
          dancers on wooden boards — characters with big eyes and heavy
          jewellery, art passed down for generations.
        </p>
        <p>
          She chose finance first: a B.S. from the Wharton School, an MBA from
          Harvard Business School, Wall Street, then years as an agent
          representing singers, musicians and visual artists. In 2009 an
          audition tape — sent at her brother's insistence — led to singing
          "Jai Ho" with A.R. Rahman at the Academy Awards, and later to the
          Hollywood Bowl with the LA Philharmonic.
        </p>
        <p>
          This time she chose the creative life. Her collections have since
          lived at Nordstrom, Dillard's, Barnes&nbsp;&amp;&nbsp;Noble, Bed
          Bath&nbsp;&amp;&nbsp;Beyond and Wayfair.
        </p>
      </div>
    </motion.div>
  </section>
);

export default BackgroundSection;
